module.exports = __webpack_public_path__ + "media/images/vp/icon.gifts-e771f1e8a77d2580f7c45ffc47e833b2.svg";